import { IAgentMode, IAgentStatus } from "../../types/agent-status";
import { IAgentStatusResponse } from "../../types/api/agent-status";

export const toFrontendStatus = (agent: IAgentStatusResponse): IAgentStatus => {
  const pausedUntil =
    agent.pausedUntil && new Date(agent.pausedUntil) > new Date()
      ? new Date(agent.pausedUntil)
      : null;
  const mode = getMode(agent.enabled, pausedUntil);
  return {
    mode: mode,
    pausedUntil: pausedUntil,
    panic: agent.panic,
  };
};

const getMode = (enabled: boolean, pausedUntil: Date | null): IAgentMode => {
  if (pausedUntil) return "paused";
  else if (!enabled) return "disabled";
  else return "active";
};
